const NoPage = () => {
    return (
        <div className="no-page">
            <h1>404 00ps! page not found</h1>
        </div>
      );
}
 
export default NoPage;